var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_209_6632",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_209_6632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.675 8.5875L10.45 6.8125C10.55 6.7125 10.6667 6.66458 10.8 6.66875C10.9333 6.67292 11.05 6.725 11.15 6.825C11.2417 6.925 11.2896 7.04167 11.2937 7.175C11.2979 7.30833 11.25 7.425 11.15 7.525L9.025 9.65C8.925 9.75 8.80833 9.8 8.675 9.8C8.54167 9.8 8.425 9.75 8.325 9.65L7.2625 8.575C7.17083 8.48333 7.12292 8.36875 7.11875 8.23125C7.11458 8.09375 7.1625 7.975 7.2625 7.875C7.35417 7.78333 7.47083 7.7375 7.6125 7.7375C7.75417 7.7375 7.87083 7.78333 7.9625 7.875L8.675 8.5875ZM3 9L1.85 10.15C1.69167 10.3083 1.51042 10.3438 1.30625 10.2563C1.10208 10.1688 1 10.0125 1 9.7875V2C1 1.725 1.09792 1.48958 1.29375 1.29375C1.48958 1.09792 1.725 1 2 1H10C10.275 1 10.5104 1.09792 10.7063 1.29375C10.9021 1.48958 11 1.725 11 2V5C11 5.14167 10.9521 5.26042 10.8562 5.35625C10.7604 5.45208 10.6417 5.5 10.5 5.5C10.3583 5.5 10.2396 5.45208 10.1438 5.35625C10.0479 5.26042 10 5.14167 10 5V2H2V8.5625L2.575 8H5.5C5.64167 8 5.76042 8.04792 5.85625 8.14375C5.95208 8.23958 6 8.35833 6 8.5C6 8.64167 5.95208 8.76042 5.85625 8.85625C5.76042 8.95208 5.64167 9 5.5 9H3Z",
    fill: "#0F2E59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.8a2ee1adb337db2c8fa99493770fc10f.svg";
export { ForwardRef as ReactComponent };